
import React, { Component } from 'react';
import PubSub from 'pubsub-js';
import { PlusOutlined, RightOutlined } from '@ant-design/icons';
import { Form, Input, Button, Checkbox, message } from "antd";
import './createGroupPage.less';
import { meshLog } from "../../../utils/spUtils";
import group from "../../../imgs/item/group.png";
import close_btn from '../../../imgs/btn/close_btn.png';
import { getSelectGroupIconsArr, judgeGroupNameExist } from '../../../utils/meshUtils';
import { createNewGroup } from '../../../utils/net/netUtils';


const { Item } = Form;
let selectId=0;
export default class CreateGroupPage extends Component {   
    constructor(props) {
        super(props);
        this.state = {
            company: '',
            groupName:"",
            groupIcons: getSelectGroupIconsArr(),
        };
    }

    //编辑框
    item1Change= (event) => {
        meshLog('item1',event.target.value);
        this.setState({ groupName: event.target.value });
    };

    //切换组的图片
    groupStateChange(item){
        meshLog("111",item.id);
        selectId=item.id;
        let arr = this.state.groupIcons;
        for (let i = 0; i < arr.length; i++) {
            arr[i].status=0;
            if(arr[i].id==item.id){
                arr[i].status=1;
            }
        }
        this.setState({
            groupIcons: arr, 
        });
    }

    //取消
    closeBtnClick(){
        this.props.onDataToParent("");
    };

    //保存
    sendDataToParentOK(){
        const { groupName } = this.state;
        if(groupName==""){
            message.warning({content:"Please input your Group Name!",style:{fontSize:"25px"}});
            return;
        }

        if(judgeGroupNameExist(groupName)){
            message.warning({content:"Names exist",style:{fontSize:"25px"}});
            meshLog('Names exist');
            return;
        }
        createNewGroup(groupName,selectId);
        this.props.onDataToParent("");
    }

    render() {
        const { groupName } = this.state;
        return (
            <div className="ui_dialog_bg">
                <div className="ui_grey_bg" />
                <div className="create_group_container"style={{left:(document.body.clientWidth-380)/2}}>
                    {/* 关闭按钮 */}
                    <img className='closeBtn' src={close_btn} onClick={() => { this.closeBtnClick() }}/>
                    {/* 1. Area Management 标题行 */}
                    <div className="group-row">
                        <div className="group-title">
                            <img className='icon' src={group}/>
                            <span>Create Group</span>
                        </div>
                        {/* <PlusOutlined className="action-icon" /> */}
                    </div>

                    {/* 2. Create group 区域 */}

                    <Input className="item1" placeholder="*Group Name" value={groupName}  maxLength={15} onChange={this.item1Change}/>

                    <div className='groupIconBg'>
                        <div className='group_list'>
                            {this.state.groupIcons.map((item) => (
                                <div key={item.id} className="group_item" onClick={() => { this.groupStateChange(item) }}>
                                    <img className="item" src={item.status==0?item.normal:item.click}/>
                                </div>
                             ))}
                        </div>
                    </div>
                    {/* 底部按钮 */}
                    <div className="group-footer">
                        <button className='cancelBtn' onClick={() => { this.closeBtnClick() }}>Cancel</button>
                         <button className='okBtn' onClick={this.sendDataToParentOK.bind(this)}>Confirm</button>
                    </div>

                </div>
            </div>
        );
    }
}
